export enum ConfiguracaoEnum {
    FinanciamentoDoacao = 1,
    FinanciamentoEmprestimo = 2,
    FinanciamentoRecompensa = 3,
    ComissaoPorCampanha = 4,
    TaxaServico = 5,
    DoacaoMinima = 6,
    DoacaoMaxima = 7,
    DuracaoMinima = 8,
    DuracaoMaxima = 9,
    QtdProjetosCriador = 10,
    PrazoAlerta = 11,
    AprovacaoCampanha = 12,
    CampanhaBemSucedida = 13,
    LimiteDoacaoPorCampanha = 14,
    DoacaoNaoPermitida = 15
}